import type { ErrorLike } from "@apollo/client";
import { isEntityWithheldError } from "./entity-withheld";
import { filterOutGraphQLErrors } from "./filter-out-graphql-errors";

/**
 * Strips entity-withheld denials from an Apollo error, judged against the
 * data they arrived beside: an error only counts as withheld when its path
 * resolves to a non-null object in `data` (the stub). The envelope contract —
 * the original error untouched when nothing was withheld, the survivors of a
 * mixed envelope (response data and extensions retained), undefined when
 * every error was a withheld denial — lives in `filterOutGraphQLErrors`. Pair
 * with `errorPolicy: "all"` so the partial data is delivered at all.
 */
export const filterOutWithheldEntityErrors = (
  error: ErrorLike | undefined,
  data: unknown,
): ErrorLike | undefined =>
  filterOutGraphQLErrors(error, (entry) => isEntityWithheldError(entry, data));
